import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./header.css";

export default function Header() {
  // const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="header">
        <div className="head-row">
          <div className="head-right">
            {/* <Link to="/admissions/DNS" className="head-btn">
              <span class="glow-text"> DNS- Female Sponsorship</span>
            </Link> */}
            <Link to="https://drive.google.com/file/d/1yrCFHHEG5RNRqOpuNBtZzzbaUbAJfrOH/view?usp=drive_link" className="head-btn">
              <span class="glow-text"> DG Approved Doctor List</span>
            </Link>
            <Link
              to="/admissions/admission-2026"
              className="head-btn admission"
            >
              <span class="glow-text"> Admission Open for A.Y. 2026-27</span>
            </Link>
          </div>
        </div>

        <div className="head-center">
          <img
            src="/assets/images/icons/manet_logo.webp"
            alt="MANET Logo Left"
            className="head-logo"
            id="manet-logo"
          />

          <div className="head-title">
            <h1 id="institute-name">
              {" "}
              Maharashtra Academy of Naval Education and Training , Pune
            </h1>
            <p id="institute-details">
              Approved by Directorate General of Shipping Govt. of India | CIP
              Grade "A1" Outstanding | ISO 9001:2015 Certified
            </p>
          </div>

          <img
            src="/assets/images/icons/mit_logo.webp"
            alt="MIT Logo Right"
            className="head-logo"
            id="head-mit-logo"
          />
          {/* <img src="/assets/images/icons/mit_logo_black.webp" alt="MIT Logo Right" className="head-logo" id="head-mobile-logo" /> */}
        </div>
      </div>
    </>
  );
}
